import type { LayoutChangeEvent } from 'react-native';
import { Pressable, StyleSheet, Text, View } from 'react-native';

import { SkillCard } from './skill-card';
import { colors } from '../theme';
import { inter500, isWeb } from '../utils/platform';
import { STACK_ITEMS } from '../utils/stack-data';

type StackSectionProps = {
  isMobile: boolean;
  onLayout: (event: LayoutChangeEvent) => void;
  onPressTitle: () => void;
};

export function StackSection({ isMobile, onLayout, onPressTitle }: StackSectionProps) {
  const leftItems = STACK_ITEMS.filter((_, index) => index % 2 === 0);
  const rightItems = STACK_ITEMS.filter((_, index) => index % 2 === 1);

  return (
    <View nativeID="stack" onLayout={onLayout} style={styles.stackSection}>
      <Pressable onPress={onPressTitle} style={styles.sectionTitleLink}>
        <Text style={styles.sectionTitle}>Stack</Text>
      </Pressable>

      <View style={[styles.stackGrid, isMobile && styles.stackGridMobile]}>
        <View style={styles.stackColumn}>
          {leftItems.map((item) => (
            <SkillCard key={item.title} {...item} />
          ))}
        </View>

        <View style={styles.stackColumn}>
          {rightItems.map((item) => (
            <SkillCard key={item.title} {...item} />
          ))}
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  stackSection: {
    gap: 32,
    paddingVertical: 30,
  },
  sectionTitleLink: {
    alignSelf: 'flex-start',
    ...(isWeb
      ? {
        cursor: 'pointer',
      }
      : null),
  },
  sectionTitle: {
    color: colors.text,
    fontFamily: inter500,
    fontSize: 20,
    fontWeight: '500',
    lineHeight: 24,
  },
  stackGrid: {
    flexDirection: 'row',
    gap: 32,
    width: '100%',
  },
  stackGridMobile: {
    flexDirection: 'column',
  },
  stackColumn: {
    flex: 1,
    gap: 32,
    overflow: 'hidden',
  },
});
